export default __webpack_public_path__ + "static/media/rohan.6c0cf4ca.png";